import { directionArr } from "../configParams";

export const coordinateValueSwitch = (xAxisValue, yAxisValue, configParams) => {
  let response = null;

  if (
    xAxisValue < -configParams.lowerLimit &&
    xAxisValue > -configParams.upperLimit &&
    Math.abs(yAxisValue) < configParams.range
  ) {
    response = directionArr[0];
  } else if (
    xAxisValue > configParams.lowerLimit &&
    xAxisValue < configParams.upperLimit &&
    Math.abs(yAxisValue) < configParams.range
  ) {
    response = directionArr[1];
  } else if (
    Math.abs(xAxisValue) < configParams.range &&
    yAxisValue < -configParams.lowerLimit &&
    yAxisValue > -configParams.upperLimit
  ) {
    response = directionArr[3];
  } else if (
    Math.abs(xAxisValue) < configParams.range &&
    yAxisValue > configParams.lowerLimit &&
    yAxisValue < configParams.upperLimit
  ) {
    response = directionArr[2];
  } else {
    response = "Repeat";
  }

  return response;
};
